import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStatInfo, handleAddPost } from "@/api/managementCenter/labelManage";
import { getAllJobList } from "@/api/managementCenter/jobManage";
import { getDeptTree } from "@/api/managementCenter/otherApi";
export default {
  name: "addLabel",
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      postList: [],
      form: {
        labelId: "",
        postList: []
      },
      rules: {
        postList: [{
          required: true,
          message: "请选择可管理岗位",
          trigger: "blur"
        }]
      },
      resData: {},
      jobList: [],
      departmentData: [],
      daptNames: "",
      //回显部门字符串
      postName: "",
      //回显岗位字符串
      tableData: [],
      labelTypeList: [{
        name: "名称",
        value: "name"
      }, {
        name: "性别",
        value: "SEX"
      }, {
        name: "年龄",
        value: "AGE"
      }, {
        name: "部门",
        value: "DEPT"
      }, {
        name: "角色",
        value: "ROLE"
      }, {
        name: "用户类型",
        value: "USER_TYPE"
      }, {
        name: "入学入职年份",
        value: "ADM_DATE"
      }],
      conditionData: [{
        value: "name",
        list: [{
          name: "等于",
          value: "eq"
        }, {
          name: "不等于",
          value: "neq"
        }]
      }, {
        value: "SEX",
        list: [{
          name: "等于",
          value: "eq"
        }]
      }, {
        value: "AGE",
        list: [{
          name: "等于",
          value: "eq"
        }, {
          name: "模糊匹配",
          value: "gt"
        }, {
          name: "大于",
          value: "lt"
        }, {
          name: "大于等于",
          value: "gte"
        }, {
          name: "小于等于",
          value: "lte"
        }]
      }, {
        value: "DEPT",
        list: [{
          name: "本部门",
          value: "deplevel"
        }, {
          name: "本部门以及下级部门",
          value: "depdownlevel"
        }]
      }, {
        value: "ROLE",
        list: [{
          name: "存在",
          value: "in"
        }, {
          name: "不存在",
          value: "nin"
        }]
      }, {
        value: "USER_TYPE",
        list: [{
          name: "等于",
          value: "eq"
        }]
      }, {
        value: "ADM_DATE",
        list: [{
          name: "等于",
          value: "eq"
        }, {
          name: "模糊匹配",
          value: "gt"
        }, {
          name: "大于",
          value: "lt"
        }, {
          name: "大于等于",
          value: "gte"
        }, {
          name: "小于等于",
          value: "lte"
        }]
      }]
    };
  },
  components: {},
  mounted: function mounted() {
    this.getJobListFn();
    this.getDeptTreeData();
  },
  methods: {
    //获取部门数据
    getDeptTreeData: function getDeptTreeData() {
      var _this = this;

      getDeptTree().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          if (data.data && data.data.length > 0) {
            if (data.data[0].id == 1) {
              _this.departmentData = data.data[0].children;
            } else {
              _this.departmentData = data.data;
            }
          }
        }
      }).catch(function (err) {});
    },
    //获取岗位数据
    getJobListFn: function getJobListFn() {
      var _this2 = this;

      getAllJobList().then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this2.jobList = data.data || [];
        } else {
          _this2.$message.warning(data.msg || "获取岗位失败！");
        }
      }).catch(function (err) {});
    },
    setId: function setId(id) {
      var _this3 = this;

      this.loading = true;
      this.daptNames = "";
      getStatInfo(id).then(function (_ref3) {
        var data = _ref3.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.postList = [];
          _this3.resData = data.data || {};

          if (_this3.resData.labelType == "1") {
            var arr = JSON.parse(_this3.resData.labelConditions).conditions;
            arr.forEach(function (item) {
              _this3.tableData.push({
                labelType: item.conditionName,
                conditionType: item.campareName,
                sexText: item.textName
              });
            });
            _this3.form.labelId = _this3.resData.labelId;
          }

          var depts = [];
          var posts = [];

          if (_this3.resData.labelType == "0") {
            _this3.resData.deptList.forEach(function (item) {
              depts.push(item.deptName);
            });

            _this3.resData.postList.forEach(function (item) {
              posts.push(item.postName);
            });

            _this3.daptNames = depts.join(",");
            _this3.postName = posts.join(",");
          }
        } else {
          _this3.$message.warning(data.msg || "获取标签信息失败！");
        }
      }).catch(function (err) {
        _this3.loading = false;
      });
    },
    goBack: function goBack() {
      this.$emit("goBack", this.resData);
    },
    saveOrUpdate: function saveOrUpdate() {
      var _this4 = this;

      this.loading = true;
      handleAddPost(this.form).then(function (_ref4) {
        var data = _ref4.data;
        _this4.loading = false;

        if (data.code == 0) {
          _this4.$message.success("修改成功!");

          _this4.$emit("saveSuccess");
        } else {
          _this4.$message.warning(data.msg || "保存失败!");
        }
      }).catch(function (err) {
        _this4.loading = false;

        _this4.$message.error("服务器异常!");
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this5 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this5.saveOrUpdate();
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    postList: function postList(val) {
      this.form.postList = (val || []).map(function (i) {
        return {
          postId: i
        };
      });
    }
  },
  filters: {
    labelTypeFilter: function labelTypeFilter(val) {
      var labelTypeList = [{
        name: "请选择",
        value: ""
      }, {
        name: "静态标签",
        value: "0"
      }, {
        name: "动态标签",
        value: "1"
      }];
      var obj = labelTypeList.find(function (i) {
        return val == i.value;
      }) || {};
      return obj.name;
    }
  }
};